import { ReactNode } from 'react';
import { SerializedStyles, css } from '@emotion/react';
import { SelectedLocationProvider, SelectedLocationProviderProps } from '@frontend/payments-hooks';
import { theme } from '@frontend/theme';
import { Heading } from '@frontend/design-system';
import * as settingStyles from '../styles/payment-settings-page.styles';

interface PaymentsCardProps {
  children: ReactNode;
  title?: string;
  action?: ReactNode;
  style?: SerializedStyles[] | SerializedStyles;
}

const paymentSettingsCardStyles = {
  card: css`
    margin-bottom: ${theme.spacing(2)};
    border: 1px solid ${theme.colors.neutral20};
    background: ${theme.colors.white};
    border-radius: ${theme.borderRadius.medium};
    box-shadow: ${theme.shadows.light};
    padding: ${theme.spacing(2, 2)};
    position: relative;
  `,

  header: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: ${theme.spacing(1, 0, 3)};
  `,
};

export const PaymentsCard = ({ children, title, action, style }: PaymentsCardProps) => {
  const cssArray = Array.isArray(style) ? style : style ? [style] : [];
  return (
    <div css={[paymentSettingsCardStyles.card, ...cssArray]}>
      {title && (
        <div css={paymentSettingsCardStyles.header}>
          <Heading level={3}>{title}</Heading>
          {action}
        </div>
      )}
      {children}
    </div>
  );
};

export const PaymentSettingsCard = ({
  children,
  title,
  action,
  style,
  locationId,
}: PaymentsCardProps & { locationId: SelectedLocationProviderProps['locationId'] }) => {
  const cssArray = Array.isArray(style) ? style : style ? [style] : [];

  return (
    <SelectedLocationProvider locationId={locationId}>
      <PaymentsCard title={title} style={[settingStyles.groupMaxWidth, ...cssArray]} action={action}>
        {children}
      </PaymentsCard>
    </SelectedLocationProvider>
  );
};
